<script>
import { HorizontalBar, mixins } from "vue-chartjs";
import AnalysisTooltip from "./analysis_tooltip.js";

const { reactiveProp } = mixins;

export default {
	name: "horizontal-bar-chart",
	extends: HorizontalBar,
	mixins: [reactiveProp],
	props: {
		chartData: Object,
		tooltipData: Array,
		valueUnit: String,
	},
	computed: {
		//complimentary data for hover tooltips i.e. percent changed
		tooltipDataProcessed() {
			if (!_.isEmpty(this.tooltipData)) {
				// @ts-expect-error
				return this.tooltipData[0].map((percent) => {
					return percent.toFixed(2);
				});
			}
		},
		chartOptions() {
			return {
				responsive: true,
				maintainAspectRatio: false,
				animation: false,
				plugins: {
					legend: {
						display: false,
					},
				},
				scales: {
					y: {
						barThickness: 20,
						ticks: {
							mirror: true,
							labelOffset: -18,
						},
						gridLines: {
							display: false,
						},
					},
					x: {
						beginAtZero: true,
						offset: true,
						gridLines: {
							display: true,
						},
						ticks: {
							callback: (value, index, values) => {
								const fromattedNumber = window
									.numeral(value)
									.format(window.numeral.formatWithUnit);
								return fromattedNumber + " " + this.valueUnit;
							},
						},
					},
				},
			};
		},
	},
	mounted() {
		let chartOptions = this.chartOptions;
		chartOptions.plugins.tooltip = AnalysisTooltip;
		// @ts-expect-error
		this.renderChart(this.chartData, this.chartOptions);
		this.$watch("chartData.datasets", this.refreshData, {});
	},
	beforeDestroy() {},
	methods: {
		refreshData() {
			let chart = this._chart;
			// @ts-expect-error
			this.chartData.datasets.forEach((dataset, i) => {
				// @ts-expect-error
				chart.data.datasets[i].data = dataset.data;
			});
			// @ts-expect-error
			chart.update();
		},
	},
};
</script>
